import React from "react";
import { Link } from "react-router-dom";
import styles from "./Terms.module.css";

const Terms = () => {
  return (
    <div className={styles.container}>
      <div className={styles.box}></div>

      <header>
        <div className={styles.topHeader}>
          <Link to="/my-account">
            <i className={styles.backIcon + " fas fa-chevron-left"}></i>
          </Link>
          <h1>Terms {"&"} Conditions</h1>
        </div>
      </header>

      <main>
        <h2>Company Privacy Policy</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea rerum ad
          magnam suscipit in velit nobis eum, quo esse facere.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea rerum ad
          magnam suscipit in velit nobis eum, quo esse facere.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea rerum ad
          magnam suscipit in velit nobis eum, quo esse facere.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea rerum ad
          magnam suscipit in velit nobis eum, quo esse facere.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea rerum ad
          magnam suscipit in velit nobis eum, quo esse facere.
        </p>
      </main>
    </div>
  );
};

export default Terms;
